import {
    TextField, Chip, Grid, withStyles
} from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";
import { styles } from "./styles";



const RegionSelector = ({handleOnChange,value,name, regions}) => {
    
    const handleChangeRegions = (event,value) => {        
        const regionList = value && value.length > 0 ? value.map(r => r.value) : 'all';
        handleOnChange(name,regionList);        
    }

    const regionValues = value ? regions.filter(rg => value.includes(rg.value)):undefined;
    return (
        <Grid item xs={4} style={{marginTop: 10}}>
            <Autocomplete
            name={name}
            value={regionValues}
            multiple
            disableCloseOnSelect
            limitTags={2}
            options={regions}
            renderInput={params => <TextField {...params} label="Regions" variant="outlined" />}
            renderTags={(tagValue, getTagProps) => {            
            return tagValue.map((option, index) => (
                <Chip {...getTagProps({ index })} label={option.value} />
            ));
            }}
            getOptionLabel={option => `[${option.value || '-'}] ${option.label}`}
            onChange={handleChangeRegions}
            />
        </Grid>
    )     
    
}
export default withStyles( styles )(RegionSelector);
